import { Code } from "@mantine/core";

interface InlineCodeProps {
  content?: string;
}

/**
 * InlineCode renders inline code as Mantine `Code`.
 */
export const InlineCode = ({ content }: InlineCodeProps) => <Code>{content}</Code>;
